<script setup lang="ts">
import LoginForm from '../components/auth/LoginForm.vue';
import AuthLayout from '../layouts/AuthLayout.vue';

definePage({
  name: 'login',
  meta: {
    isPublic: true,
  },
});
</script>

<template>
  <AuthLayout>
    <LoginForm />
  </AuthLayout>
</template>
